import { useState, useEffect } from 'react';
import * as appStorage from '../utils/appIndexedDB';

export const THEME_STORAGE_KEY = 'mygenie_theme';

export function getStoredTheme() {
  if (typeof window === 'undefined') return 'light';
  const raw = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (raw === 'light' || raw === 'dark') return raw;
  return 'light';
}

function persistTheme(theme) {
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    }
  } catch (e) {}
}

export function applyThemeToDocument(theme) {
  if (theme === 'light') {
    document.documentElement.setAttribute('data-theme', 'light');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
}

/**
 * 與 PageHeader 先前邏輯相同：state 同步到 data-theme 與 localStorage。
 */
export function useTheme() {
  const [theme, setTheme] = useState(getStoredTheme);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // 一次性遷移：若 localStorage 沒有主題，從 IndexedDB 讀舊值並搬移。
    const migrateLegacyTheme = async () => {
      const localTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
      if (localTheme === 'light' || localTheme === 'dark') return;

      try {
        const legacyTheme = await appStorage.getItem(THEME_STORAGE_KEY);
        if (legacyTheme === 'light' || legacyTheme === 'dark') {
          window.localStorage.setItem(THEME_STORAGE_KEY, legacyTheme);
          setTheme(legacyTheme);
        }
      } catch (e) {
        // noop
      } finally {
        try {
          await appStorage.removeItem(THEME_STORAGE_KEY);
        } catch (e) {
          // noop
        }
      }
    };

    void migrateLegacyTheme();
  }, []);

  useEffect(() => {
    applyThemeToDocument(theme);
    persistTheme(theme);
  }, [theme]);

  return { theme, setTheme };
}
